import * as THREE from 'three';
import {
  GLTFLoader
} from 'three/examples/jsm/loaders/GLTFLoader.js';
import gsap from 'gsap';
import './style.css';
import {
  OrbitControls
} from 'three/examples/jsm/controls/OrbitControls.js';
import * as dat from 'dat.gui';
import 'dat.gui/build/dat.gui.css';
import Stats from 'stats.js';
import {
  FontLoader
} from 'three/src/loaders/FontLoader.js';
import {
  TextGeometry
} from 'three/src/geometries/TextGeometry.js';
//import {GUI} from "./dat_gui_settings";

const container = document.getElementById('container');
const intro = document.getElementById('intro');
const ingresarBtn = document.getElementById('ingresar');
const preloader = document.getElementById('preloader');
const progressBar = document.getElementById('progress-bar');
const progressText = document.getElementById('progress-text');

let scene, camera, renderer, grupo1, grupo2, cube, fog, video, videoTexture, fontLoader, textureLoader, listener, audioLoader, sound, mixer, mixer2, generateGalaxy;
const clock = new THREE.Clock();
const loadingManager = new THREE.LoadingManager();

const params = {
  backgroundColor: 0x2e2e2e
};

// dat gui renderer background
const gui = new dat.GUI({
  width: 320,
});
gui.close();

var cubeProps = {
  scale: 0.6
};

// Add a control to the GUI for the scale property
gui.add(cubeProps, 'scale', 0.1, 1).name('Cube Size');

// Add the backgroundColor parameter directly to the GUI
gui.addColor(params, 'backgroundColor').name('Background Color').onChange(() => {
  renderer.setClearColor(params.backgroundColor);
});

// agrego stats // hay que importar y update en animate
const stats = new Stats();

// ------------------------------------------------------------------

function init() {

  scene = new THREE.Scene();
  camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);

  renderer = new THREE.WebGLRenderer();
  renderer.setSize(window.innerWidth, window.innerHeight);
  container.appendChild(renderer.domElement);

  renderer.setClearColor(params.backgroundColor);

  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.shadowMapSoft = true;

  const controls = new OrbitControls(camera, renderer.domElement);

  camera.position.set(Math.PI * 2, 2, 10);
  controls.update();

  // simple cube
  const geometry2 = new THREE.BoxGeometry();
  const material2 = new THREE.MeshStandardMaterial({
    wireframe: true,
  });
  cube = new THREE.Mesh(geometry2, material2);
  scene.add(cube);
  cube.position.set(3, 4, 0);
  cube.scale.set(0.6, 0.6, 0.6);
  cube.castShadow = true;

    /**
   * Textures
   */
    const textureLoader = new THREE.TextureLoader(loadingManager)
    const matcapTexture = textureLoader.load('Textures/cromo.png')
    const matcapTexture2 = textureLoader.load('Textures/gris.png')

  // ---------------- particulas galaxia ------------------------------------------------------------------------
  const parameters = {
    count: 30000,
    size: 0.01,
    radius: 20,
    branches: 10,
    spin: 5,
    randomness: 1,
    randomnessPower: 1,
    insideColor: '#424242',
    outsideColor: '#3d3d3d'
  };

  let
    geometry = null,
    material = null,
    points = null;


    let generateGalaxy = function () {

    if (points !== null) {
      geometry.dispose()
      material.dispose()
      scene.remove(points)
    }

    /**
     * Geometry galaxy 
     */
    geometry = new THREE.BufferGeometry();

    let
      positions = new Float32Array(parameters.count * 3),
      colors = new Float32Array(parameters.count * 3),
      colorInside = new THREE.Color(parameters.insideColor),
      colorOutside = new THREE.Color(parameters.outsideColor);

    for (let i = 0; i < parameters.count; i++) {

      let
        i3 = i * 3,

        radius = Math.random() * parameters.radius,
        spinAngle = radius * parameters.spin,
        branchAngle = (i % parameters.branches) / parameters.branches * Math.PI * 2,

        randomX = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : -1) * parameters.randomness * radius,
        randomY = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : -1) * parameters.randomness * radius,
        randomZ = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : -1) * parameters.randomness * radius;

      positions[i3] = Math.cos(branchAngle + spinAngle) * radius + randomX;
      positions[i3 + 1] = +randomY;
      positions[i3 + 2] = Math.sin(branchAngle + spinAngle) * radius + randomZ;

      let mixedColor = colorInside.clone();
      mixedColor.lerp(colorOutside, radius / parameters.radius);

      colors[i3] = mixedColor.r
      colors[i3 + 1] = mixedColor.g
      colors[i3 + 2] = mixedColor.b
    }

    geometry.setAttribute(
      'position',
      new THREE.BufferAttribute(positions, 3)
    );

    geometry.setAttribute(
      'color',
      new THREE.BufferAttribute(colors, 3)
    );

    /**
     * Material
     */
    material = new THREE.PointsMaterial({
      size: parameters.size,
      sizeAttenuation: true,
      depthWrite: false,
      blending: THREE.AdditiveBlending,
      vertexColors: true
    });

    points = new THREE.Points(geometry, material);
    points.position.set(0, 7, 0);
    scene.add(points);
  }

  generateGalaxy();


  // dat gui para galaxia  --------------------------------------------------
  gui.add(parameters, 'count', 10000, 100000, 1000).name('Particles').step(1000).onFinishChange(generateGalaxy);
  gui.add(parameters,
    'size',
    0.001,
    0.1,
    0.001
  ).name('Particles Size').onFinishChange(generateGalaxy);
  gui.addColor(
    parameters,
    'insideColor'
  ).name('Particles Inside Color').onFinishChange(generateGalaxy);

  gui.addColor(
    parameters,
    'outsideColor'
  ).name('Particles Outside Color').onFinishChange(generateGalaxy);

  // ----------------------- fin de  particulas



 
  /// fontt
  const fontLoader = new FontLoader()

  fontLoader.load(
    'Fonts/ms.json',
    (font) => {
      // Material
      const material = new THREE.MeshMatcapMaterial({
        matcap: matcapTexture
      })
      const material2 = new THREE.MeshMatcapMaterial({
        matcap: matcapTexture2
      })

      // Text
      const textGeometry = new TextGeometry(
        '©', // massimple logo
        {
          font: font,
          size: 2,
          height: 0.7,
          curveSegments: 12,
          bevelEnabled: true,
          bevelThickness: 0.03,
          bevelSize: 0.02,
          bevelOffset: 0,
          bevelSegments: 20
        }
      )
      textGeometry.center()

      const text = new THREE.Mesh(textGeometry, material)
      scene.add(text)
      grupo2.add(text);
      text.castShadow = true;
      text.position.set(-2.5, 1, 2); // x, y, z
      text.scale.set(0.5, 0.5, 0.3); // x, y, z

      // gsap para animaciones green sock library
      gsap.to(text.rotation, {
        duration: 5,
        y: Math.PI * -2,
        repeat: -1,
        ease: "none"
      });
    }
  )
  // fin font --------------------------------

  /// ------ video  element
  // Create a video element
  video = document.createElement('video');
  video.src = 'Video/massimple.mp4';
  video.autoplay = true;
  video.loop = true;
  video.muted = true;

  // Parte trasera de la pantalla
  const relleno = new THREE.Mesh(
    new THREE.BoxGeometry(1, 1, 1),
    new THREE.MeshStandardMaterial({
      color: '#333333'
    })
  )
  scene.add(relleno)
  relleno.position.set(0.07, 3.55, -3.2); // x, y, z menos es mas lejos
  relleno.scale.set(6.8, 3.98, 0.05); // x, y, z

  // Create a texture from the video
  const videoTexture = new THREE.VideoTexture(video);
  videoTexture.minFilter = THREE.LinearFilter;
  videoTexture.magFilter = THREE.LinearFilter;
  videoTexture.format = THREE.RGBFormat;

  // Create a material with the video texture
  var material3 = new THREE.MeshBasicMaterial({
    map: videoTexture
  });

  // Create a mesh with a plane geometry and the material
  var geometry3 = new THREE.PlaneGeometry(16, 9);
  var vidi1 = new THREE.Mesh(geometry3, material3);

  // Set the position and scale of the mesh
  vidi1.position.set(0.09, 3.56, -3.15); // x, y, z menos es mas lejos
  vidi1.scale.set(0.42, 0.43, 1); // x, y, z
  //mesh.rotation.x = Math.PI;

  // Add the mesh to the scene
  scene.add(vidi1);

  // Escuchar el evento click del botón y luego disparo video
  ingresarBtn.addEventListener('click', function () {
    if (video.paused) {
      // Iniciar la reproducción del video si está en pausa
      video.play();
    }
  });

  //--------- fin video element code -------------------

//  Ambient light
  const ambientLight = new THREE.AmbientLight(0x404040); // soft white light
  scene.add(ambientLight)
  ambientLight.intensity = 1

  // Directional light
  const moonLight = new THREE.DirectionalLight('404040', 0.1)
  moonLight.position.set(1, 10, 15)
  moonLight.intensity = 2
  gui.add(moonLight, 'intensity', 1, 3, 0.01).name('Light Intensity');
  gui.add(moonLight.position, 'x').min(-5).max(5).step(0.001).name('Light X');
  gui.add(moonLight.position, 'y').min(0).max(10).step(0.001).name('Light Y');
  gui.add(moonLight.position, 'z').min(-5).max(15).step(0.001).name('Light Z');
  scene.add(moonLight)
  moonLight.castShadow = true;
  moonLight.shadow.mapSize.width = 1048;
  moonLight.shadow.mapSize.height = 1048;
  moonLight.shadow.bias = -0.005;
  moonLight.shadow.camera.near = 0.5; // default value is 0.5
  moonLight.shadow.camera.far = 500; // default value is 500

  // helper para la camara direccional
  // const directionalLightCameraHelper = new THREE.CameraHelper(moonLight.shadow.camera)
  // scene.add(directionalLightCameraHelper);

  listener = new THREE.AudioListener();
  camera.add(listener);

  audioLoader = new THREE.AudioLoader();
  sound = new THREE.Audio(listener);


  // -------------------------------------------------------------------

  // cargadores de modelos 3d
  const loader = new GLTFLoader(loadingManager);
  const ModelPath = 'Models/George.gltf';
  const ModelPath2 = 'Models/Plataforma.gltf';
  const ModelPath3 = 'Models/Pantalla.gltf';
  const ModelPath4 = 'Models/Plataforma-mini.gltf';

  // modelo robot uno
  loader.load(
    ModelPath,
    function (gltf) {
      gltf.scene.scale.set(0.5, 0.5, 0.5);
      scene.add(gltf.scene);
      gltf.scene.position.set(-1.7, 0, -0.5);
      gltf.scene.rotation.y = 45;
      gltf.scene.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = true;
        }
      });
      // grupo2
      grupo2.add(gltf.scene);
      console.log('modelo bull');
      mixer = new THREE.AnimationMixer(gltf.scene);
      const ACTION = mixer.clipAction(gltf.animations[5]);
      ACTION.play();
    },
    function (xhr) {
      console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    function (error) {
      console.log('Error loading GLTF model: ' + error);
    }
  );

  // modelo robot segundo
  loader.load(
    ModelPath,
    function (gltf) {
      gltf.scene.scale.set(0.5, 0.5, 0.5);
      scene.add(gltf.scene);
      console.log(gltf.scene);
      gltf.scene.position.set(1.5, 0, 0);
      gltf.scene.traverse((child) => {
        if (child.isMesh) {
          child.castShadow = true;
        }
      });
      // grupo2
      grupo2.add(gltf.scene);
      console.log('modelo bio');
      mixer2 = new THREE.AnimationMixer(gltf.scene);
      mixer2.timeScale = 0.7; // establezco velocidad y tambien en animate
      const ACTION = mixer2.clipAction(gltf.animations[2]);
      ACTION.play();
    },
    function (xhr) {
      console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    function (error) {
      console.log('Error loading GLTF model: ' + error);
    }
  );

  // modelo plataforma
  loader.load(
    ModelPath2,
    function (gltf) {
      gltf.scene.scale.set(2, 2, 2);
      scene.add(gltf.scene);
      console.log(gltf.scene);
      gltf.scene.position.set(0, 0, -4);
      gltf.scene.rotation.y = Math.PI;
      gltf.scene.traverse((child) => {
        if (child.isMesh) {
          child.receiveShadow = true;
          //    child.castShadow = true;
        }
      });
      // grupo2
      grupo2.add(gltf.scene);
      console.log('modelo plataforma');
    },
    function (xhr) {
      console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    function (error) {
      console.log('Error loading GLTF model: ' + error);
    }
  );

  // modelo pantalla
  loader.load(
    ModelPath3,
    function (gltf) {
      gltf.scene.scale.set(0.13, 0.13, 0.13);
      scene.add(gltf.scene);
      gltf.scene.position.set(0, 1.5, -3);
      gltf.scene.traverse((child) => {
        if (child.isMesh) {
          child.receiveShadow = true;
        }
      });
      // Add the model to the group
      grupo1.add(gltf.scene);
      console.log('modelo pantalla');
    },
    function (xhr) {
      console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    function (error) {
      console.log('Error loading GLTF model: ' + error);
    }
  );

  // modelo plataforma mini
  loader.load(
    ModelPath4,
    function (gltf) {
      gltf.scene.scale.set(1, 1, 1);
      scene.add(gltf.scene);
      console.log(gltf.scene);
      gltf.scene.position.set(-2.5, 0, 2);
      gltf.scene.rotation.y = Math.PI;
      gltf.scene.traverse((child) => {
        if (child.isMesh) {
          child.receiveShadow = true;
          // child.castShadow = true;
        }
      });
      // grupo2
      grupo2.add(gltf.scene);
      console.log('modelo plataforma mini');
    },
    function (xhr) {
      console.log((xhr.loaded / xhr.total) * 100 + '% loaded');
    },
    function (error) {
      console.log('Error loading GLTF model: ' + error);
    }
  );

  // stats panel
  stats.showPanel(1); // 0: fps, 1: ms, 2: mb, 3+: custom
  document.body.appendChild(stats.dom);

  // grupo1 ---- pantalla video y fondo
  const grupo1 = new THREE.Group();
  // grupo2 ---- plataforma y todo lo que esta sobree ella
  const grupo2 = new THREE.Group();

  // agrego a grupo1 -- el modelo se agrega desde dentro de la funcion
  grupo1.add(vidi1);
  grupo1.add(relleno);

  // Set the position of the group
  grupo1.position.set(0, 0, 0);
  grupo2.position.set(0, 0, 0);

  // Add the group to the scene
  scene.add(grupo1);
  scene.add(grupo2);

  // Create a new timeline
  const voladora = gsap.timeline({
    repeat: -1
  });
  // Define the animation
  voladora
    .to(grupo1.rotation, 5, {
      z: '-=0.1'
    }) // Small rotation
    .to(grupo1.rotation, 3, {
      x: '+=0.1'
    }) // Small rotation
    .to(grupo1.rotation, 5, {
      z: '+=0.1'
    }) // Small rotation
    .to(grupo1.rotation, 3, {
      x: '-=0.1'
    }); // Small rotation
  // Start the animation
  voladora.play();

  // Create a new timeline for the gsap animation grupo2
  const flotante = gsap.timeline({
    repeat: -1
  });
  // Define the animation of grupo2
  flotante
    .to(grupo2.position, 1.3, {
      y: '-=0.4',
      ease: 'sine.inOut'
    })
    .to(grupo2.position, 1.3, {
      y: '+=0.4',
      ease: 'sine.inOut'
    });
  // Start the animation
  flotante.play();

  animate();
}

// listener al click event then play audio
ingresarBtn.addEventListener('click', () => {
  gsap.to(intro, {
    opacity: 0,
    duration: 1,
    onComplete: () => {
      intro.style.display = 'none';
      intro.style.opacity = 1;
    },
  });
  playAudio();
});

function playAudio() {
  audioLoader.load('Audio/sound.mp3', (buffer) => {
    sound.setBuffer(buffer);
    sound.setLoop(true); // Set the loop property to true
    sound.setLoop(true);
    sound.setVolume(0.5);
    sound.onEnded = function () {
      console.log('Audio ended');
    };
    sound.onLoaded = function () {
      console.log('Audio loaded');
    };
    sound.play();
  });
}

function animate() {
  requestAnimationFrame(animate);

  // actualizo  video texture
  const videoTexture = new THREE.VideoTexture(video);
  if (video.readyState === video.HAVE_ENOUGH_DATA) {
    videoTexture.needsUpdate = true;
  }

  // Update cube scale based on gui value
  cube.scale.set(cubeProps.scale, cubeProps.scale, cubeProps.scale);

  gui.updateDisplay();

  cube.rotation.x += 0.02;
  cube.rotation.y += 0.02;

  // Update the clock
  const delta = clock.getDelta();

  if (mixer) {
    mixer.update(delta);
  }

  if (mixer2) {
    mixer2.update(delta * mixer2.timeScale);
  }

  renderer.render(scene, camera);

  stats.update(); // Add this line to update the stats
}

init();


// preload real ---------------------------------------

loadingManager.onProgress = function (url, loaded, total) {
  progressBar.style.width = `${(loaded / total) * 100}%`;
  progressText.textContent = `${Math.floor((loaded / total) * 100)}%`;
};

loadingManager.onLoad = function () {
  gsap.to(preloader, {
    opacity: 0,
    duration: 0,
    onComplete: () => {
      preloader.style.opacity = 1;
      preloader.style.display = 'none';
      intro.style.display = 'flex';
      // ingresarBtn.click(); // Trigger the click event on the ingresarBtn
      console.log('All files loaded');
    },
  });
};

// fin preload ------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  const volumeSlider = document.getElementById('volume-slider');

  // Set the initial value of the volume slider to the middle of its range
  volumeSlider.value = volumeSlider.max / 2;

  volumeSlider.addEventListener('input', () => {
    sound.setVolume(volumeSlider.value);
  });
});